// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*export const environment = {
	production: false,
	apiUrl: 'http://localhost:8000/api/v1',
	testUrl: 'http://localhost:8000/api/v1',
	ticketingApiUrl: 'http://localhost:8888',
	documentUrl: 'https://ams-document-backup.s3.ap-south-1.amazonaws.com/'
};
*/
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
export const environment = {
  production: false,
  apiUrl: 'https://crc-ams.corecotechnologies.com/api/v1',
  testUrl: 'https://crc-ams.corecotechnologies.com/api/v1',
  ticketingApiUrl: 'http://175.100.138.197:8888',
  documentUrl: 'https://ams-document-backup.s3.ap-south-1.amazonaws.com/'
};
